import React, { Fragment } from "react";

// import Ionicon from 'react-ionicons';

import { IoIosCalendar } from "react-icons/io";
import { store } from "../../../stores";
import PerfectScrollbar from "react-perfect-scrollbar";

import {
  DropdownToggle,
  DropdownMenu,
  Nav,
  Col,
  Row,
  Button,
  NavItem,
  NavLink,
  UncontrolledTooltip,
  UncontrolledButtonDropdown,
} from "reactstrap";

import { message } from "antd";

import { toast, Bounce } from "react-toastify";

import { faAngleDown } from "@fortawesome/free-solid-svg-icons";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import city3 from "../../../assets/utils/images/dropdown-header/city3.jpg";
//import avatar1 from "../../../assets/utils/images/avatars/1.jpg";
// import avatar1 from "../../../assets/utils/images/avatars/avatar-ngoctrinh.jpg";
import avatar1 from "../../../assets/utils/images/avatars/icon-doctor.jpg";
import ChangePassModal from "../../../OneLIS/DMS/ConfigCatalog/UserManagement/User/changePassModal";
import { connect } from "react-redux";
import {
  getConfigValueByKey,
  hasPermission,
} from "../../../Components/utility";
import history from "../../../../src/stores/history";
import { onFetchListConfigBase } from "../../../Api/AppBackend/Config";
import UserManagement from "../../../OneLIS/DMS/ConfigCatalog/UserManagement/User/userManagement";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Dashboard from "../../../Views/QuickView/Dashboard";
import { withTranslation } from "react-i18next";

class UserBox extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      active: false,
      changePassModal: false,
      isUseAccountAd: false,
      // showUserManagement: false,
      typeUser: null,
    };
  }

  notify2 = () =>
    (this.toastId = toast(
      "You don't have any new items in your calendar for today! Go out and play!",
      {
        transition: Bounce,
        closeButton: true,
        autoClose: 5000,
        position: "bottom-center",
        type: "success",
      }
    ));

  setChangePassModal = () => {
    this.state.changePassModal == false
      ? this.setState({ changePassModal: true })
      : this.setState({ changePassModal: false });
  };
  setChangePassModal = () => {
    this.setState({ changePassModal: !this.state.changePassModal });
  };

  setcloseUserManagementTable = () => {
    this.setState({ showUserManagement: false });
  };

  // setToggleUserManagement = () => {
  //   this.setState((prevState) => ({
  //     showUserManagement: !prevState.showUserManagement,
  //   }));
  // };

  async getConfig() {
    try {
      const response = await onFetchListConfigBase();
      if (response.data.isSuccess) {
        this.setState({
          isUseAccountAd: getConfigValueByKey(
            response.data.data,
            "USE_ACCOUNT_AD"
          ),
        });
      } else {
        this.setState({ isUseAccountAd: false });
      }
    } catch (err) {
      this.setState({ isUseAccountAd: false });
    }
  }

  componentDidMount() {
    this.getConfig();
    const typeUser = localStorage.getItem("typeUser");
    this.setState({ typeUser });
  }

  render() {
    const logout = () => {
      localStorage.setItem("token", "");
      localStorage.setItem("name", "");
      localStorage.setItem("groupid", "");
      localStorage.setItem("title", "");
      localStorage.setItem("userID", "");
      localStorage.removeItem("typeUser");
      store.dispatch({ type: "USER_SET_DATA", data: { token: "", name: "" } });
      history.push("/login");
    };

    return (
      <Fragment>
        {/* Nếu showUserManagement là false thì hiển thị UserBox */}
        {!this.state.showUserManagement ? (
          <div className="header-btn-lg pr-0 float-right">
            <div className="widget-content p-0">
              <div className="widget-content-wrapper">
                <div className="widget-content-left">
                  {!this.props.global.userID && (
                    <Button
                      onClick={() => {
                        history.push("/login");
                      }}
                    >
                      {this.props.t('LogIn')}
                    </Button>
                  )}
                  {this.props.global.userID && (
                    <UncontrolledButtonDropdown>
                      <DropdownToggle color="link" className="p-0">
                        <img
                          width={42}
                          className="rounded-circle"
                          src={avatar1}
                          alt=""
                        />
                        <FontAwesomeIcon
                          className="ml-2 opacity-8"
                          icon={faAngleDown}
                        />
                      </DropdownToggle>

                      <DropdownMenu
                        right
                        className="rm-pointers dropdown-menu-lg"
                      >
                        <div className="dropdown-menu-header">
                          <div className="dropdown-menu-header-inner bg-info">
                            <div
                              className="menu-header-image opacity-2"
                              style={{
                                backgroundImage: "url(" + city3 + ")",
                              }}
                            />
                            <div className="menu-header-content text-left">
                              <div className="widget-content p-0">
                                <div className="widget-content-wrapper">
                                  <div className="widget-content-left mr-3">
                                    <img
                                      width={42}
                                      className="rounded-circle"
                                      src={avatar1}
                                      alt=""
                                    />
                                  </div>
                                  <div className="widget-content-left">
                                    <div className="widget-heading">
                                      {this.props.global.userID}
                                    </div>
                                    <div className="widget-subheading opacity-8">
                                      {this.props.global.name}
                                    </div>
                                  </div>
                                  <div className="widget-content-right mr-2">
                                    <Button
                                      onClick={logout}
                                      className="btn-pill btn-shadow btn-shine"
                                      color="focus"
                                    >
                                      {this.props.t('LogOut')}
                                    </Button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="scroll-area-xs"
                          style={{ height: "190px" }}
                        >
                          {this.state.typeUser === "1" && (
                            <NavItem>
                              <NavLink
                                onClick={() => {
                                  history.push("/dashboard");
                                }}
                              >
                                {this.props.t('Dashboard Summarize')}
                              </NavLink>
                              <NavLink
                                onClick={() => {
                                  history.push("/usermanagerment");
                                }}
                              >
                                {this.props.t('User Management')}
                              </NavLink>
                            </NavItem>
                          )}
                          {["1","2","3"].includes(this.state.typeUser) && (
                            <NavItem>
                              <NavLink
                                onClick={() => {
                                  history.push("/listpatient");
                                }}
                              >
                                {this.props.t('List of patients')}
                              </NavLink>
                            </NavItem>
                          )}
                          {["1","2","3"].includes(this.state.typeUser) && (
                            <NavItem>
                              <NavLink
                                onClick={() => {
                                  history.push("/");
                                }}
                              >
                                {this.props.t('Test result list')}
                              </NavLink>
                            </NavItem>
                          )}
                          <NavItem
                            style={{
                              borderBottom: "1px solid rgb(227 225 225)",
                            }}
                          >
                            <NavLink onClick={this.setChangePassModal}>
                            {this.props.t('Change Password')}
                            </NavLink>
                          </NavItem>
                        </div>
                      </DropdownMenu>
                    </UncontrolledButtonDropdown>
                  )}
                </div>
                <div className="widget-content-left  ml-3 header-user-info">
                  <div
                    className="widget-heading"
                    style={{
                      textShadow:
                        "2px 0 #fff, -2px 0 #fff, 0 2px #fff, 0 -2px #fff, 1px 1px #fff, -1px -1px #fff, 1px -1px #fff, -1px 1px #fff",
                      opacity: 1,
                    }}
                  >
                    {this.props.global.userID}
                  </div>
                  <div
                    className="widget-subheading"
                    style={{
                      textShadow:
                        "2px 0 #fff, -2px 0 #fff, 0 2px #fff, 0 -2px #fff, 1px 1px #fff, -1px -1px #fff, 1px -1px #fff, -1px 1px #fff",
                      opacity: 1,
                    }}
                  >
                    {this.props.global.name}
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div
            style={{
              position: "fixed",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              zIndex: "1000",
              backgroundColor: "white",
              boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
              borderRadius: "8px",
              padding: "20px",
              width: "100%",
              maxWidth: "1000px",
              maxHeight: "90vh",
              overflowY: "hidden",
              overflowX: "hidden",
            }}
          >
            <Button
              onClick={this.setcloseUserManagementTable}
              style={{
                position: "absolute",
                top: "10px",
                right: "10px",
                borderRadius: "50%",
                width: "30px",
                height: "30px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: "#f00",
                color: "#fff",
                border: "none",
                cursor: "pointer",
                zIndex: "10000",
              }}
            >
              X
            </Button>
            <UserManagement />
          </div>
        )}

        <ChangePassModal
          globalState={this.props.global}
          changePassModal={this.state.changePassModal}
          setChangePassModal={this.setChangePassModal}
          curChangePassUser={this.props.global}
        />
      </Fragment>
    );
  }
}

// export default UserBox;
const mapStateToProps = (state) => ({
  global: state.global,
});
export default connect(mapStateToProps)(
 withTranslation(["dashboard"]) (UserBox));
